module.exports = window["AFFWP"]["portal"]["sdk"];